import {
    useEffect,
    useState,
} from 'react'
import isEmpty from 'lodash/isEmpty'

import FormWithControls from 'app/shared-components/FormWithControls'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import StatusHandler from 'app/shared-components/StatusHandler'

import useGetServiceCenterById from '../hooks/useGetServiceCenterById'
import {
    ProductMetricsType,
    ServiceCenterFormType,
} from '../serviceCenters.types'
import fields from './poolingDataUpdate.fields'

const PoolingDataUpdate = ({
    id,
}: Readonly<{ id: number }>) => {
    const [
        value,
        setValue,
    ] = useState<{productMetrics: ProductMetricsType[]}>()

    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetServiceCenterById(id)

    useEffect(() => {
        if (data) {
            setValue({
                productMetrics: data.productMetrics,
            })
        }
    }, [data])

    const modifyDataBeforeSend = (
        dataForm: {
            productMetrics: ProductMetricsType[],
        },
    ): Partial<ServiceCenterFormType> => {
        return {
            productMetrics: dataForm?.productMetrics?.filter((item) => {
                return !isEmpty(item) && Object.values(item).every((el) => {
                    return Boolean(el) || el === 0
                })
            }),
        }
    }

    return (
        <StatusHandler
            isError={isError}
            isFetching={isFetching}
            error={error}
            isSuccess={isDataReady}
        >
            <FormWithControls
                onSuccess={invalidate}
                value={value}
                setExternalValue={setValue}
                name={request.domainName}
                fields={fields}
                requestParams={request.poolingUpdate({
                    id: data?.id,
                })}
                modifyDataBeforeSend={modifyDataBeforeSend}
                exists
            />
        </StatusHandler>
    )
}

export default PoolingDataUpdate
